import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Map from './map';
import './MapPage.css';

function MapPage() {
  const navigate = useNavigate();
  const [allowMultipleLines, setAllowMultipleLines] = useState(true); // Default: ON (multi-select)
  const [showLegend, setShowLegend] = useState(false); // Mobile legend
  const [legendExpanded, setLegendExpanded] = useState(false); // Desktop legend expansion

  // Set default to false (one line at a time) on mobile
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      setAllowMultipleLines(false);
    }
  }, []);

  return (
    <div className="map-page">
      {/* Desktop back button */}
      <button 
        className="back-button desktop-only"
        onClick={() => navigate('/')}
      >
        ← Back
      </button>
      
      {/* Desktop legend - collapsible */}
      <div className={`legend desktop-only ${legendExpanded ? 'expanded' : 'collapsed'}`}>
        <div 
          className="legend-header"
          onClick={() => setLegendExpanded(!legendExpanded)}
        >
          <h3 className="legend-title">Legend</h3>
          <span className="legend-expand-icon">{legendExpanded ? '−' : '+'}</span>
        </div>
        {legendExpanded && (
          <div className="legend-content">
            <div className="legend-item">
              <div className="legend-circle job-circle"></div>
              <span className="legend-label">Job</span>
            </div>
            <div className="legend-item">
              <div className="legend-circle project-circle"></div>
              <span className="legend-label">Project/Accomplishment</span>
            </div>
            
            <div className="legend-divider"></div>
            
            <label className="legend-toggle">
              <input 
                type="checkbox" 
                checked={allowMultipleLines}
                onChange={(e) => setAllowMultipleLines(e.target.checked)}
              />
              <span className="legend-label">Allow Multiple Lines</span>
            </label>
            
            {allowMultipleLines && (
              <div className="multi-mode-indicator">Multi-mode active</div>
            )}
          </div>
        )}
      </div>

      {/* Mobile bottom bar */}
      <div className="mobile-bottom-bar">
        <button 
          className="mobile-back-button"
          onClick={() => navigate('/')}
        >
          ← Back
        </button>
        <button 
          className="mobile-legend-button"
          onClick={() => setShowLegend(!showLegend)}
        >
          Legend
        </button>
      </div>

      {/* Mobile legend modal */}
      {showLegend && (
        <div 
          className="mobile-legend-overlay"
          onClick={() => setShowLegend(false)}
        >
          <div 
            className="mobile-legend-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mobile-legend-header">
              <h3 className="legend-title">Legend</h3>
              <button 
                className="mobile-legend-close"
                onClick={() => setShowLegend(false)}
              >
                ×
              </button>
            </div>
            <div className="legend-item">
              <div className="legend-circle job-circle"></div>
              <span className="legend-label">Job</span>
            </div>
            <div className="legend-item">
              <div className="legend-circle project-circle"></div>
              <span className="legend-label">Project/Accomplishment</span>
            </div>
            
            <div className="legend-divider"></div>
            
            <label className="legend-toggle">
              <input 
                type="checkbox" 
                checked={allowMultipleLines}
                onChange={(e) => setAllowMultipleLines(e.target.checked)}
              />
              <span className="legend-label">Allow Multiple Lines</span>
            </label>
            
            {allowMultipleLines && (
              <div className="multi-mode-indicator">Multi-mode active</div>
            )}
          </div>
        </div>
      )}
      
      <Map allowMultipleLines={allowMultipleLines} />
    </div>
  );
}

export default MapPage;

